<template>
  <validation-observer ref="validationobserver" v-slot="{ }">
    <div v-if="screenBlockedMountEdit"></div>
    <b-form v-else @submit.prevent="salvarPrazo">
      <b-card header-tag="header" class="m-3" no-body>
        <template #header>
          <h6 class="mb-0 text-center">
            <span class="titulo-sagres font-weight-bold">
              {{ isEdit ? 'Editar' : 'Cadastrar' }} Prazo de LRFCI
            </span>
            <btn-voltar />
            <b-button class="float-right m-1" size="sm" type="submit">
              <font-awesome-icon icon="save" />
              Salvar
            </b-button>
          </h6>
        </template>
        <b-card-body>
          <b-row>
            <b-col cols="6" xl="3">
              <validation-provider rules="required" v-slot="validationContext" name="exercicio">
                <b-form-group id="input-group-exercicio" label-size="md" label="Exercício (ano)*">
                  <b-form-select id="select-exercicio" v-model="prazo.Exercicio" :options="comboExercicios"
                    :state="getValidationState(validationContext)" :disabled="isEdit">
                  </b-form-select>
                  <b-form-invalid-feedback id="select-exercicio-live-feedback">
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col cols="6" lg="3">
              <validation-provider rules="required" v-slot="validationContext" name="periodo-prestacao">
                <b-form-group id="input-group-periodo-prestacao" label-size="md" label="Período Prestação">
                  <b-form-select id="select-filtros-periodo-prestacao" v-model="prazo.PeriodoPrestacao"
                    :options="comboPeriodosPrestacao" :disabled="isEdit">
                  </b-form-select>
                  <b-form-invalid-feedback id="select-periodo-prestacao-live-feedback">
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="6" lg="3">
              <validation-provider rules="required" v-slot="validationContext" name="periodo-relatorio">
                <b-form-group id="input-group-periodo-relatorio" label-size="md" label="Período de Relatório">
                  <b-form-select id="select-filtros-periodo-relatorio" v-model="prazo.PeriodoRelatorio"
                    :options="comboPeriodosRelatorio" :disabled="isEdit">
                  </b-form-select>
                  <b-form-invalid-feedback id="select-periodo-relatorio-live-feedback">
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col cols="6" xl="3">
              <validation-provider rules="required" v-slot="validationContext" name="tipo-relatorio">
                <b-form-group id="input-group-tipo-relatorio" label-size="md" label="Tipo de Relatório *">
                  <b-form-select id="select-tipo-relatorio" v-model="prazo.IdTiporelatorio" :options="comboTiposRelatorio"
                    @change="atualizarPeriodo" :state="getValidationState(validationContext)" :disabled="isEdit">
                  </b-form-select>
                  <b-form-invalid-feedback id="select-tipo-relatorio-live-feedback">
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="6">
              <b-form-group label-class="text-left" id="data-vencimento-input-group" label="Data de Vencimento *"
                label-for="input-data-vencimento">
                <b-form-datepicker id="input-data-vencimento" v-model="prazo.DataVencimento"
                  placeholder="Selecione uma data" value-as-date label-no-date-selected="Nenhuma data selecionada"
                  reset-button label-reset-button="Limpar" label-help="Use as setas para navegar pelas datas"
                  label-prev-year="Ano anterior" label-prev-month="Mês anterior" label-current-month="Mês atual"
                  label-next-month="Próximo mês" label-next-year="Próximo ano">
                </b-form-datepicker>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group label-class="text-left" id="data-vencimento-original-input-group"
                label="Data de Vencimento Original*" label-for="input-data-vencimento-original">
                <b-form-datepicker id="input-data-vencimento-original" v-model="prazo.DataVencimentoOriginal" reset-button
                  label-reset-button="Limpar" placeholder="Selecione uma data" value-as-date
                  label-no-date-selected="Nenhuma data selecionada" label-help="Use as setas para navegar pelas datas"
                  label-prev-year="Ano anterior" label-prev-month="Mês anterior" label-current-month="Mês atual"
                  label-next-month="Próximo mês" label-next-year="Próximo ano">
                </b-form-datepicker>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group id="justificativa-input-group" label="Justificativa" label-for="input-justificativa">
                <b-form-input id="input-justificativa" class="w-100" v-model="prazo.Justificativa">
                </b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </b-form>
  </validation-observer>
</template>

<script lang="ts">
import { Vue, Component, Ref } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import BtnVoltar from '@/components/shared/BtnVoltar.vue'

import { ValidationProvider, ValidationObserver } from "vee-validate";
import { store } from "@/store";
import { UtilsTS } from '@/utilsts'

import prazosService from "@/services/administracao/prazosService";
import { SelectValue } from '@/types/select-value';
import { PrazoDeVencimentoLRFCI } from '@/types/administracao/prazos-lrfci/prazo-de-vencimento-lrfci';

const CompProps = Vue.extend({
  name: 'EditarPrazoVencimentoLRFCI',
  components: {
    BtnVoltar,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    idprazo: {
      type: String,
      required: false
    }
  }
})

@Component
export default class EditarPrazoVencimentoLRFCI extends mixins(UtilsTS, CompProps) {
  @Ref('validationobserver') validationobserver: InstanceType<typeof ValidationObserver>
  comboEsferas: SelectValue[] = []
  comboExercicios: SelectValue[] = []
  comboPeriodosPrestacao: SelectValue[] = []
  comboPeriodosRelatorio: SelectValue[] = []
  comboTiposRelatorio: SelectValue[] = []
  prazo = new PrazoDeVencimentoLRFCI()

  get isEdit() {
    return this.idprazo !== undefined && this.idprazo !== null
  }
  get screenBlockedMountEdit() {
    return store.blockScreen && this.isEdit
  }

  async salvarPrazo(): Promise<void> {
    try {
      store.blockScreen = true
      const isValid = await this.validationobserver.validate();
      if (!isValid) {
        //console.log(this.validationobserver)
        return
      }
      const response = this.isEdit ? await prazosService.editarPrazoVencimentoLRFCI(this.prazo) : await prazosService.criarPrazoVencimentoLRFCI(this.prazo);
      if (response && response.status == 200) {
        this.$toast.success(`Prazo ${this.isEdit ? 'editado' : 'cadastrado'} com sucesso!`);
        this.$router.push("/seguranca-administracao/prazos-vencimento-lrf");
      } else {
        this.$toast.error(response.data.msg || "Erro ao salvar prazo de vencimento");
      }
    } catch (e: any) {
      console.error('Erro ao salvar prazo de vencimento', e, this.prazo)
      this.$toast.error(e.message || "Erro ao salvar prazo de vencimento")
    } finally {
      store.blockScreen = false
    }
  }
  getValidationState({ dirty, validated, valid = null }): any {
    return dirty || validated ? valid : null;
  }
  atualizarPeriodo(): void {
    /* if (this.prazo.Referencia === 99 || this.prazo.Referencia === 999)
      this.prazo.PeriodoPrestacao = 'ANUAL'
    else
      this.prazo.PeriodoPrestacao = 'MENSAL' */
  }

  async getCombos(): Promise<void> {
    try {
      const combos = await prazosService.getCombosLRFCI()
      this.comboExercicios = combos.exercicios.map(ex => ({ text: String(ex), value: ex }))
      this.comboPeriodosPrestacao = combos.periodosPrestacao.map(ex => ({ text: String(ex), value: ex }))
      this.comboPeriodosRelatorio = combos.periodosRelatorio.map(pr => ({ text: pr.DePeriodorelatorio, value: pr.IdPeriodorelatorio }))
      this.comboTiposRelatorio = combos.tiposRelatorio.map(tr => ({ text: tr.DeTiporelatorio, value: tr.IdTiporelatorio }))
    } catch (e: any) {
      console.error('Erro ao obter combos de prazos de vencimento (LRF)', e)
      throw e
    }
  }

  async mounted(): Promise<void> {
    try {
      store.blockScreen = true
      await this.getCombos()
      if (this.isEdit) {
        const prazoApi = await prazosService.getPrazoVencimentoLRFCI(this.idprazo)//trocar
        if (prazoApi && prazoApi.status === 200) {
          this.prazo = Object.assign(this.prazo, prazoApi.data)
          this.prazo.tratarDadosDaAPI()
        } else {
          this.$router.push("/seguranca-administracao/prazos-vencimento-lrf");
          this.$toast.error(prazoApi.data.msg || "Erro ao carregar prazo de vencimento");
        }
      }
    } catch (e: any) {
      console.error('Erro ao montar edição de prazos de vencimento', e)
      this.$router.push("/seguranca-administracao/prazos-vencimento-lrf");
      this.$toast.error(e.message || "Erro ao carregar prazo de vencimento");
    } finally {
      store.blockScreen = false
    }
  }
};
</script>

<style></style>